import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { CartListTable } from "@/components/carts/table";
import { useGetAllCarts } from "@/hooks/api/cart/useGetAllCarts";
import { useDebounce } from "@/hooks/useDebounce";
import { AppPage } from "@/layouts/page";

export const CartsPage = () => {
  let [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const initialPage = searchParams.get("page")
    ? parseInt(searchParams.get("page")!)
    : 1;

  const [pageParams, setPageParams] = useState({
    page: initialPage,
    limit: 10,
  });

  const { data: carts, isFetching: isCartsLoading } = useGetAllCarts({
    ...pageParams,
    searchTerm: debouncedSearchTerm,
  });

  useEffect(() => {
    const urlPage = searchParams.get("page");

    if (urlPage) {
      const page = parseInt(urlPage);

      setPageParams((prev) => ({ ...prev, page }));
    } else {
      // If no page in URL, reset to page 1
      setPageParams((prev) => ({ ...prev, page: 1 }));
    }
  }, [searchParams]);

  const handleLimitChange = (limit: number) => {
    setPageParams((prev) => ({ ...prev, limit }));
    handlePageChange(1);
  };

  const handlePageChange = (newPage: number) => {
    searchParams.set("page", newPage.toString());
    setSearchParams(searchParams);
  };

  const handleSearchTermChange = (newSearchTerm: string) => {
    setSearchTerm(newSearchTerm);
  };

  return (
    <AppPage subtitle={carts ? `${carts.total.toLocaleString()} carts in total` : undefined} title="Carts">
      <CartListTable
        changePage={handlePageChange}
        handleSearchTermChange={handleSearchTermChange}
        limit={pageParams.limit}
        onLimitChange={handleLimitChange}
        isLoading={isCartsLoading}
        items={carts?.data ?? []}
        page={pageParams.page ?? 1}
        searchTerm={searchTerm}
        totalCarts={carts?.total ?? 0}
      />
    </AppPage>
  );
};
